import * as React from "react";
import startchat from "../../img/startchatwhite.svg"
import { ContactActions } from "./ContactActions";

export function ContactCard({ contact, hasChat }) {
  const { name, title, email, phones } = contact;

  return (
    <div className="p-1">
      <div className="mb-4">
        <div className="flex justify-between items-start">
          <div>
            <h2 
              className="text-xl text-gray-500 font-normal mb-0.5 truncate hover:text-clip" 
              title={name}
            >
              {name}
            </h2>
            <p className="text-gray-500 text-xs">{title}</p>
          </div>
          <ContactActions contact={contact} />
        </div>
      </div>

      <div className="space-y-2">
        {/* Email section */}
        <div>
          <div className="pl-[5px]">
            <div className="text-gray-500 text-xs mb-0.5">Email</div>
          </div>
          <div className="pl-[5px] relative">
            <div className="absolute -left-[18px] -top-[2px]">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3332 5.00001C18.3332 4.08334 17.5832 3.33334 16.6665 3.33334H3.33317C2.4165 3.33334 1.6665 4.08334 1.6665 5.00001M18.3332 5.00001V15C18.3332 15.9167 17.5832 16.6667 16.6665 16.6667H3.33317C2.4165 16.6667 1.6665 15.9167 1.6665 15V5.00001M18.3332 5.00001L9.99984 10.8333L1.6665 5.00001" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <a href={`mailto:${email}`} className="text-red-600 text-sm">
              {email}
            </a>
          </div>
        </div>

        <div className="flex gap-8">
          <div>
            <div className="pl-[5px]">
              <div className="text-gray-500 text-xs mb-0.5">Work Phone</div>
            </div>
            <div className="pl-[5px] relative">
              <div className="absolute -left-[18px] -top-[2px]">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 3C2 2.44772 2.44772 2 3 2H5.15287C5.64171 2 6.0589 2.35341 6.13927 2.8356L6.87858 7.27147C6.95075 7.70451 6.73206 8.13397 6.3394 8.3303L4.79126 9.10437C5.90756 11.8783 8.12168 14.0924 10.8956 15.2087L11.6697 13.6606C11.866 13.2679 12.2955 13.0492 12.7285 13.1214L17.1644 13.8607C17.6466 13.9411 18 14.3583 18 14.8471V17C18 17.5523 17.5523 18 17 18H15C7.8203 18 2 12.1797 2 5V3Z" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <a href={`tel:${phones[0]}`} className="text-red-600 text-sm">
                {phones[0]}
              </a>
            </div>
          </div>

          <div>
            <div className="pl-[5px]">
              <div className="text-gray-500 text-xs mb-0.5">Mobile</div>
            </div>
            <div className="pl-[5px] relative">
              <div className="absolute -left-[18px] -top-[2px]">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2H7C5.89543 2 5 2.89543 5 4V16C5 17.1046 5.89543 18 7 18H13C14.1046 18 15 17.1046 15 16V4C15 2.89543 14.1046 2 13 2Z" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 15H10.01" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <a href={`tel:${phones[1]}`} className="text-red-600 text-sm">
                {phones[1]}
              </a>
            </div>
          </div>
        </div>
      </div>

      {hasChat && (
        <button 
          className="flex gap-1 items-center px-2 py-0.5 mt-3 text-xs font-medium text-white bg-red-700 rounded"
          tabIndex={0}
        >
          <img src={startchat} alt="" className="w-3 h-3" />
          <span>Start Chat</span>
        </button>
      )}
    </div>
  );
}
